import { Contract as DraftProtos } from '@qover-private/protos-web/qover/dojo/tesla/v1/contract';
import { DraftFactory } from '@qover/domain';
import { Draft } from '../Draft';
import { Make, Model, RiskProps } from '../Risk';
import { TermsProps } from '../Terms';

export function createFromApiResponse(response?: DraftProtos): Draft {
  const draft = DraftFactory.createFromApiResponse({
    ...response,
    calculatedField: response?.calculatedField,
    error: undefined,
    nextVersion: undefined,
    payment: response?.payment,
    policyholder: response?.policyholder,
    previousVersions: [],
    refs: response?.refs,
    risk: undefined,
    settings: response?.settings,
    terms: undefined,
    totalCoverage: response?.totalCoverage,
    versionInfo: response?.versionInfo,
  });

  return new Draft({
    ...draft,
    risk: ((response?.risk ?? {
      make: Make.MAKE_TESLA,
      model: Model.MODEL_S,
    }) as unknown) as RiskProps,
    terms: ((response?.terms ?? {}) as unknown) as TermsProps,
  });
}
